/**
 * Topbar Component
 * - description: 타이틀 옆 (i) 아이콘 툴팁 (짧은 안내 문구)
 * - subtitle: 타이틀 아래 그대로 노출 (링크, ID 등 클릭/복사가 필요한 정보)
 * - leading: 타이틀 왼쪽 요소 (뒤로가기 버튼 등)
 * - badge: 타이틀 오른쪽 상태 배지 (<Badge> 등)
 */

import { Tooltip } from '../ui';
import InfoIcon from '../../assets/icons/common/info.svg?react';

interface TopbarProps {
  title: React.ReactNode;
  description?: React.ReactNode;
  subtitle?: React.ReactNode;
  actions?: React.ReactNode;
  leading?: React.ReactNode;
  badge?: React.ReactNode;
}

export function Topbar({ title, description, subtitle, actions, leading, badge }: TopbarProps) {
  const heading = (
    <div className="topbar-text">
      <div className="topbar-heading">
        <h1 className="topbar-title">{title}</h1>
        {description && (
          <Tooltip content={description} placement="right">
            <button type="button" className="topbar-info" aria-label="페이지 설명">
              <InfoIcon />
            </button>
          </Tooltip>
        )}
        {badge}
      </div>
      {subtitle && <p className="topbar-sub">{subtitle}</p>}
    </div>
  );

  return (
    <header className="topbar">
      {leading ? (
        <div className="topbar-main">
          {leading}
          {heading}
        </div>
      ) : heading}
      {actions && <div className="topbar-actions">{actions}</div>}
    </header>
  );
}

export default Topbar;
